import { render } from "./Notification.vue?vue&type=template&id=4d33cb40"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
script.render = render

export default script